import type { Filters } from '@shared/types/Accommodations.types';
import { ACCOMMODATIONS_DEFAULT_LOCATION } from '@shared/constants/accommodations';

export const PRICE_RANGE = {
  MIN: 0,
  MAX: 1000,
} as const;

export const DEFAULT_OCCUPANCY = {
  unitCount: 1,
  occupancies: [
    {
      adults: 2,
      childrenAges: [],
    },
  ],
};

export const DEFAULT_SEARCH_RADIUS = 4; // Default search radius in km

export const DEFAULT_LOCATION = {
  destination: ACCOMMODATIONS_DEFAULT_LOCATION.name,
  lat: ACCOMMODATIONS_DEFAULT_LOCATION.lat,
  lng: ACCOMMODATIONS_DEFAULT_LOCATION.long,
  googlePlaceId: ACCOMMODATIONS_DEFAULT_LOCATION.placeId,
} as const;

export const QUERY_PARAM_KEYS = {
  checkin: 'checkin',
  checkout: 'checkout',
  destination: 'destination',
  lat: 'lat',
  lng: 'lng',
  radius: 'radius',
  rooms: 'rooms',
  googlePlaceId: 'googlePlaceId',
};

/**
 * Curated tags an inbound link asks us to lead with, e.g.
 * `?prioritizeTag=honeymoon&prioritizeTag=luxury`. Repeated key, not
 * comma-delimited — see usePrioritizeTagsQueryParam.
 *
 * Deliberately not in FILTER_QUERY_PARAM_KEYS: it is an inbound context hint, not
 * user-toggled filter state, so "clear filters" must leave it alone.
 */
export const PRIORITIZE_TAG_QUERY_PARAM_KEY = 'prioritizeTag';

export const FILTER_QUERY_PARAM_KEYS = {
  FACILITIES: 'facilities',
  STAR_RATING: 'starRating',
  USER_RATING: 'userRating',
  PRICE_MIN: 'priceMin',
  PRICE_MAX: 'priceMax',
  CUG: 'cug',
  PICKED_BY_COUPLE: 'pickedByCouple',
  SHOW_AVAILABLE_ONLY: 'showAvailableOnly',
  PROPERTY_CATEGORIES: 'propertyCategories',
  BRANDS: 'brands',
  FREE_CANCELLATION: 'freeCancellation',
  CASH_FUND_COVERED: 'cashFundCovered',
};

export const DEFAULT_FILTERS: Filters = {
  facilities: [],
  starRating: [],
  userRating: [],
  priceRange: [PRICE_RANGE.MIN, PRICE_RANGE.MAX],
  cug: false,
  pickedByCouple: false,
  showAvailableOnly: true,
  propertyCategories: [],
  brands: [],
  freeCancellation: false,
  cashFundFullyCoveredOnly: false,
};

export const SORT_QUERY_PARAM_KEY = 'sort';
